import { en } from './locales/en';
import { da } from './locales/da';
import { type Locale } from './types';

type TranslationParams = Record<string, string | number>;

const dictionaries: Record<Locale, typeof en> = { da, en };

const getNestedValue = (dictionary: object, key: string): unknown => {
  return key.split('.').reduce<unknown>((current, part) => {
    if (current && typeof current === 'object' && part in current) {
      return (current as Record<string, unknown>)[part];
    }

    return undefined;
  }, dictionary);
};

const translate = (
  locale: Locale,
  key: string,
  params?: TranslationParams
): string => {
  const dictionary = dictionaries[locale];
  const fallback = getNestedValue(en, key);
  const value = getNestedValue(dictionary, key) ?? fallback;

  if (typeof value !== 'string') {
    return key;
  }

  if (!params) {
    return value;
  }

  return Object.entries(params).reduce(
    (result, [paramKey, paramValue]) =>
      result.replace(`{{${paramKey}}}`, String(paramValue)),
    value
  );
};

const getDateLocale = (locale: Locale) => (locale === 'da' ? 'da-DK' : 'en-US');

export { translate, getDateLocale, dictionaries };
